<form [formGroup]="form" class="mdl" id="mdl-form" *ngIf="showEdit">

  <div class="loader" *ngIf="showLoader">
    <lib-loading></lib-loading>
  </div>

  <div class="mdl-ctn" *ngIf="!showLoader">
    <div class="mdl-bnr">
      <div class="mdl-img-banner">
        <img [src]="form.get('banner_image_url').value ? form.get('banner_image_url').value : banner" alt="Banner Lopes Brasil">
        <span>Alterar Cover</span>
      </div>
      <div class="mrg mdl-img-pfl">
        <img [src]="form.get('profile_image_url').value ? form.get('profile_image_url').value : profile" alt="Logo Lopes Brasil">
        <span>Alterar Foto</span>
      </div>
    </div>
    <div class="mrg mdl-nuser">
      <p class="nick">{{ form.get('nickname').value }}</p>
      <p class="user-name">{{ form.get('name').value }}</p>
    </div>
    <div class="mrg mdl-group md-eml">
      <div class="phone-input">
        <label for="telephone">Telefone Principal</label>
        <app-flag-input id="telephone" class="email-input" (changes)="setPhone($event, 1)" [phone]="form.get('phone').value"></app-flag-input>
      </div>
      <div class="phone-input">
        <label for="phone-alternative">Telefone Alternativo</label>
        <app-flag-input id="phone-alternative" class="email-input" (changes)="setPhone($event, 2)" [phone]="form.get('alternative_phone').value"></app-flag-input>
      </div>
    </div>
    <div class="mrg mdl-group md-eml">
      <div class="mdl-item">
        <label for="email">Email</label>
        <input type="email" id="email" [readonly]="true" formControlName="email" name="email" placeholder="corretor@lopes.com.br">
      </div>
    </div>
    <div class="mrg mdl-group md-eml">
      <div class="mdl-item">
        <label class="mdl-lb-bio" for="bio">Biografia:</label>
        <textarea type="text" formControlName="biography" id="bio" name="bio" placeholder="Escreva um breve resumo sobre você." maxlength="280"></textarea>
        <small class="mdl-count">{{ form.get('biography').value.length + '/' + '280' }}</small>
      </div>
    </div>
    <div class="mrg mdl-idioma">
      <div class="mdl-list">
        <p class="mdl-text">Idiomas:</p>
        <div class="item-selection">
          <div class="item-select" *ngFor="let item of form.get('languages').value; let i = index">

            <app-list-action
              class="idiomas"
              [dataValue]="item.language"
              [indexList]="i"
              [list]="locations"
              (setIdioma)="setIdioma(i, $event.location, 'loc')"
            ></app-list-action>

            <app-list-action
              class="idiomas"
              [dataValue]="item.proficiency"
              [indexList]="i"
              [list]="listType"
              (setIdioma)="setIdioma(i, $event.location, 'tp')"
            ></app-list-action>
            
            <button class="btn-clear-position" id="mdl-clear-position-{{i}}" (click)="clearIdioma(i)">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z" fill="#2A2A2A"/>
              </svg>
            </button>
          </div>
          <button class="btn btn-add-idioma" id="mdl-add-idiomas" (click)="addIdioma()">
            Adicionar idioma
          </button>
        </div>
      </div>
    </div>
    <div class="mrg mdl-actions">
      <div class="btn-holder">
        <lib-button-primary id="btn-submited" [icon]="''" [maxWidth]="''" (click)="submitForm()">Salvar Alterações</lib-button-primary>
      </div>
      <button type="button" class="btn btn-cancel" id="btn-cancel-form" (click)="showEdit = false; sendOpen.emit(showEdit)">Cancelar</button>
    </div>
  </div>
</form>
